import { ACTIVE_CUSTOMER_DISPLAY } from 'redux/types'

const initState = {
  isActiveCustomerDisplay: false,
}

export default function customerDisplayReducer(state = initState, action) {
  switch (action.type) {
    case ACTIVE_CUSTOMER_DISPLAY:
      return {
        ...state,
        isActiveCustomerDisplay: action.payload,
      }

    default:
      return state
  }
}
